// IANA time-zone helpers.

export function getTimeZones(): string[] {
  // Intl.supportedValuesOf is ES2022; our TS lib target is ES2020, hence the
  // typed access. Every browser this app targets ships it, so the only fallback
  // we need is the user's own zone.
  const intl = Intl as typeof Intl & {
    supportedValuesOf?: (key: string) => string[]
  }
  if (typeof intl.supportedValuesOf === 'function') {
    return intl.supportedValuesOf('timeZone')
  }
  return [getDefaultTimeZone()]
}

export function getDefaultTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  } catch {
    return 'UTC'
  }
}

// The API accepts every zone id Java knows, and a browser throws a RangeError on
// some of them ("GMT+05:30"). Such a zone gives no date, so that the page still renders.
export function formatDateInTimeZone(
  epochSeconds: number,
  timeZone: string
): string | undefined {
  try {
    return new Intl.DateTimeFormat('en-US', {
      timeZone,
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }).format(new Date(epochSeconds * 1000))
  } catch {
    return undefined
  }
}
